import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import logo from "../Assets/Images/ncs-logo.svg";
import { setloadTost } from "../redux/slices/toastSlice";
import {
  createCorporateApplicationForm,
  editCorporateApplicationForm,
  fetchCorporateApplication,
} from "../redux/slices/corporateRegistrationSlice";
import { removeUser } from "../redux/slices/authSlice";
import { generateCorporateFormData } from "../components/generateCorporateFormData";
import CorporateApplicationFormHeader from "../components/CorporateApplicationFormHeader";
import CorporateOrgForm from "../components/CorporateOrgForm";
import CorporateOwnerForm from "../components/CorporateOwnerForm";
// import CorporateNcsMemberForm from "../components/CorporateNcsMemberForm";
import CorporateSponsorForm from "../components/CorporateSponsorForm";
import CorporateUploadDocForm from "../components/CorporateUploadDocForm";
import { useBreakpointValue } from "@chakra-ui/react";

const CorporateApplicationForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({});
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [saveloading, setSaveloading] = useState(false);
  const [error, setError] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [approved, setApproved] = useState(false);
  const [declined, setDeclined] = useState(false);
  const [comment, setComment] = useState("");
  const [formSave, setFormSave] = useState(false);
  const [noData, setNoData] = useState(false);

  const errorsArray = Array.isArray(error) ? error : [error];
  // const max = 4; // Number of steps

  const signOut = () => {
    dispatch(removeUser());
    localStorage.removeItem("persist:root");
    navigate("/");
  };

  const handleNext = (data) => {
    setFormData((prev) => ({ ...prev, ...data }));
    setActiveStep((prev) => Math.min(prev + 1, max));
    console.log("Hey: ", data);
  };

  const handlePrevious = () => {
    setActiveStep((prev) => Math.max(prev - 1, 0));
  };
  const getRegisteredIndividual = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const response = await dispatch(fetchCorporateApplication());
      if (response?.payload?.data?.isSuccess === true) {
        if (
          response?.payload?.data?.isSubmitted === true &&
          response?.payload?.data?.status === "Pending"
        ) {
          setLoading(false);
          setSubmitted(true);
        } else if (
          response?.payload?.data?.isSubmitted === true &&
          response?.payload?.data?.status === "Approved"
        ) {
          setLoading(false);
          setApproved(true);
        } else if (
          response?.payload?.data?.isSubmitted === true &&
          response?.payload?.data?.status === "Declined"
        ) {
          setLoading(false);
          setDeclined(true);
          setComment(response?.payload?.data?.comment);
        } else if (response?.payload?.data?.isSubmitted === false) {
          setLoading(false);
          setFormSave(true);
        }
      } else {
        if (response?.payload?.response?.status === 404) {
          setLoading(false);
          setNoData(true);
        } else if (response?.payload?.response?.status === 401) {
          dispatch(removeUser());
          localStorage.removeItem("persist:root");
          navigate("/");
        } else {
          setLoading(false);
          setError(
            response?.payload?.response?.data?.errors?.map(
              (errors) => errors
            ) ||
              response?.payload?.response?.data?.error?.description ||
              "Failed to get Applicaion Form, please check your request/network"
          );
        }
      }
    } catch (error) {
      setError(
        error?.payload?.message ||
          "Failed to get Applicaion Form, please check your request/network"
      );
    } finally {
      setLoading(false);
    }
  }, [dispatch, navigate]);

  useEffect(() => {
    getRegisteredIndividual();
  }, [getRegisteredIndividual]);

  const handleSubmitOrSave = async (data, isFinalSubmit = true) => {
    const updatedFormData = { ...formData, ...data };
    setFormData(updatedFormData);

    try {
      const corporateFormData = await generateCorporateFormData(
        updatedFormData,
        isFinalSubmit
      );
      isFinalSubmit ? setLoading(true) : setSaveloading(true);
      setError("");

      const response = await dispatch(
        isFinalSubmit
          ? createCorporateApplicationForm(corporateFormData)
          : editCorporateApplicationForm(corporateFormData)
      );

      if (response?.payload?.isSuccess) {
        dispatch(
          setloadTost({
            title: "Application Submitted",
            description: "Corporate Application submitted successfully",
            status: "success",
            duration: 5000,
            isClosable: true,
            position: "top",
          })
        );
        if (isFinalSubmit) navigate("/");
      } else {
        setError(
          response?.payload?.errors?.join(", ") ||
            response?.payload?.error?.description ||
            "Failed to process the application"
        );
      }
    } catch (error) {
      setError(error?.message || "Network error, please try again");
    } finally {
      isFinalSubmit ? setLoading(false) : setSaveloading(false);
    }
  };

  const steps = [
    {
      title: "Organization Details",
      form: <CorporateOrgForm handleNext={handleNext} />,
    },
    {
      title: "Directors & Owners",
      form: (
        <CorporateOwnerForm
          handlePrevious={handlePrevious}
          handleNext={handleNext}
        />
      ),
    },
    // {
    //   title: "NCS Members",
    //   form: (
    //     <CorporateNcsMemberForm
    //       handlePrevious={handlePrevious}
    //       handleNext={handleNext}
    //     />
    //   ),
    // },
    {
      title: "Referee Info",
      form: (
        <CorporateSponsorForm
          handlePrevious={handlePrevious}
          handleNext={handleNext}
        />
      ),
    },
    {
      title: "Documents Upload",
      form: (
        <CorporateUploadDocForm
          handlePrevious={handlePrevious}
          handleSubmit={(data) => handleSubmitOrSave(data, true)}
          handleSaveRegLater={(data) => handleSubmitOrSave(data, false)}
          loading={loading}
          saveloading={saveloading}
        />
      ),
    },
  ];

  const max = steps.length - 1;
  const progressPercent = (activeStep / max) * 100;
  const orientation = useBreakpointValue({
    base: "vertical",
    md: "vertical",
    lg: "horizontal",
  });
  const appData = {
    logo,
    signOut,
    error,
    errorsArray,
    steps,
    activeStep,
    setActiveStep,
    progressPercent,
    orientation,
    submitted,
    formSave,
    noData,
    formData,
    approved,
    declined,
    comment,
  };
  return <CorporateApplicationFormHeader {...appData} />;
};

export default CorporateApplicationForm;
